module.exports = {
  CHARTS_COLORS: {
    baseBlue: '#1E7FE2',
    baseGreen: '#007E62',
    // Naranjo de gráficos del design system (el mismo de bp-portal y bp-admin): lo usa el chat de agentes de bp-core.
    baseOrange: '#ff5f00',
  },
  BRAND_COLORS: {
    baseRed: '#E34400',
  },
};
